<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "MarketplaceSKUActionLayout"
    }
</script>

<style scoped>

</style>
